import React, { Suspense } from "react";
import { Spin } from "antd";
const BonusRequestContainer = React.lazy(
  () => import("../../modules/BonusRequest/components/index")
);

const BonusRequestPage = () => (
  <Suspense fallback={<Spin />}>
    <BonusRequestContainer />
  </Suspense>
);

export default BonusRequestPage;
